import {
  Button,
  Col,
  Form,
  Row,
  message,
  Select,
  DatePicker,
  Space,
  Input,
} from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  reportService,
  materialTypeService,
  stockIssueService,
} from "_services";
import { ReceiptType } from "_helpers";
import ColumnGroup from "antd/lib/table/ColumnGroup";

function AvailableStockSearch({ onSearch }) {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    let paramList = [];

    if (values?.customRefNumber) {
      paramList.push(
        `customRefNumber=${encodeURIComponent(
          values?.customRefNumber.toString()
        )}`
      );
    }

    if (values?.stockTypeCode) {
      paramList.push(
        `stockTypeCode=${encodeURIComponent(values?.stockTypeCode.toString())}`
      );
    }

    if (values?.stockTypeName?.length > 5) {
      paramList.push(`stockTypeName=${values?.stockTypeName}`);
    }

    const searchParams = paramList.length > 0 ? `?${paramList.join("&")}` : "";

    onSearch(searchParams);
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
      // initialValues={intialValues}
    >
      <Row gutter={24}>
        <Col span={4}>
          <Form.Item name="customRefNumber" label="Cus.Dec.No">
            <Input placeholder="Customs reference number" allowClear />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item name="stockTypeCode" label="HScode">
            <Input placeholder="HScode" allowClear />
          </Form.Item>
        </Col>
        {/* <Col span={4}>
           <Form.Item name="receiptType" label="Import Type">
            <Select>
              {ReceiptType.map((item) => (
                <Select.Option value={item.value} key={item.value}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item> 
        </Col>
*/}

        <Col span={4}>
          {/* <Form.Item name={["product", "name"]} label="Finished Good">
            <Select
              showSearch
              allowClear
              showArrow={false}
              optionFilterProp="children"
              placeholder="Finished Good"
              onChange={handleBomSelectionChange}
              onClear={() => {
                setSelectedBom(null);

                form.resetFields(["stockType", "name"], ["stockType", "id"]);
                form.setFieldValue(["stockType", "name"], null);
              }}
            >
              {boms?.map((t) => (
                <Select.Option value={t.name} key={t.id}>
                  {t.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item> */}
        </Col>
        <Col span={8}></Col>
        <Col span={4}>
          <Space align="center">
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                onFinish();
              }}
            >
              Clear
            </Button>
          </Space>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Item name={["store", "id"]}>
            <Input hidden></Input>
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name={["product", "id"]}>
            <Input hidden></Input>
          </Form.Item>
        </Col>
        <Col>
          <Form.Item name={["stockType", "id"]}>
            <Input hidden></Input>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

export default AvailableStockSearch;
